import { render } from "./TrainerCard.vue?vue&type=template&id=87cdbd54&scoped=true"
import script from "./TrainerCard.vue?vue&type=script&lang=js"
export * from "./TrainerCard.vue?vue&type=script&lang=js"

import "./TrainerCard.vue?vue&type=style&index=0&id=87cdbd54&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87cdbd54"]])

export default __exports__